import ifcLoadModel from "./ifcLoadModel";
import {pointCloudLoadModel} from "./pointCloudLoadModel";
import { cityLoadModel } from "./cityLoadModel";

export const loadModels = async (viewer) => {
    console.log("🔄 Loading all models...");

    try {
        const ifcModel = await ifcLoadModel(viewer);
        const cityModel = await cityLoadModel(viewer);
        const pointCloudModel = await pointCloudLoadModel(viewer);

        return { ifcModel, cityModel, pointCloudModel };
    } catch (error) {
        console.error("❌ Error loading models:", error);
    }
};